import { AUTHORITIES } from '@app/constants/authorities'
import { LOADING } from '@app/constants/redux-state'
import useLocalization from '@app/hooks/useLocalization'
import { IOrganizationType } from '@app/interfaces/organization/organization-type'
import OrganizationTypeForm from '@app/pages/reference-book-page-details/organization-type/components/organization-type-form/organization-type-form'
import { getOrganizationTypes } from '@app/store/actions/organization-types-actions'
import { rolesChecker } from '@app/utils/roles-checker/rolesChecker'
import { setDocumentTitle } from '@app/utils/set-document-title/set-document-title'
import { Card, Table, Tag } from 'antd'
import axios from 'axios'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'

interface props {
  _organizationTypes: IOrganizationType[]
  _state: string
}

const ReferenceBookOrganizationTypes: React.FC<props> = ({
  _organizationTypes,
  _state,
}) => {
  const [t] = useTranslation()
  const { localizeData } = useLocalization()
  const dispatch = useDispatch()
  setDocumentTitle(t('organizationType.title'))

  useEffect(() => {
    const source = axios.CancelToken.source()
    if (isEmpty(_organizationTypes))
      dispatch(getOrganizationTypes({ source }, t('organizationType.error')))
    return () => {
      source.cancel('Component got unmounted')
    }
  }, [])

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('organizationType.organizationType'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('general.status'),
      dataIndex: 'status',
      key: 'status',

      render: (tags) => (
        <>
          {tags.map((tag) => {
            const color = tag === true ? 'green' : 'volcano'
            const text =
              color === 'green' ? t('general.active') : t('general.inActive')
            return (
              <Tag color={color} key={tag}>
                {text}
              </Tag>
            )
          })}
        </>
      ),
    },
    {
      title: t('general.action'),
      key: 'action',
      render: (text, record) =>
        rolesChecker([
          AUTHORITIES.ADMIN,
          AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
        ]) ? (
          <OrganizationTypeForm
            edit={true}
            organizationType={record.organizationType}
          />
        ) : null,
    },
  ]

  const data = !isEmpty(_organizationTypes)
    ? _organizationTypes.map((organizationType) => {
        return {
          key: organizationType.id,
          id: organizationType.id,
          name: localizeData(organizationType?.data)?.name,
          status: [organizationType.status],
          organizationType: organizationType,
        }
      })
    : []

  return (
    <>
      <Card
        extra={
          rolesChecker([
            AUTHORITIES.ADMIN,
            AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
          ]) ? (
            <OrganizationTypeForm />
          ) : null
        }
        title={t('organizationType.title')}
      >
        <Table
          pagination={false}
          loading={_state === LOADING}
          dataSource={data}
          columns={columns}
        />
      </Card>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    _organizationTypes: state.organizationTypes.organizationTypes,
    _state: state.organizationTypes.state,
  }
}

export default connect(mapStateToProps)(ReferenceBookOrganizationTypes)
